import { r } from "../../_Services/LanguageService";

export function confirmAction(onConfirm: Function, description: string = r("Are you sure?")): void {
    if (confirm(description)) {
        onConfirm();
    }
}